import {Article} from './types';

export const getLeagues = (article: Article) =>
  article.tags
    .filter(({type}) => type === 'leagues')
    .map(({name}) => name.en)
    .join(', ') || null;

export const stripParagraphs = (text: string) => text.replace(/<p>|<\/p>/g, '');
